// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"36683292","303":"7921bb87","829":"6e38844b","878":"92751c03"}[chunkId] + ".chunk.js";
};